var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-btn" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("代理下单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form", { attrs: { model: _vm.contractGoods } }, [
        _c("div", { staticClass: "block-container" }, [
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("选择合同")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("合同编号")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x bottom-line",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.contractNo,
                      callback: function($$v) {
                        _vm.contractNo = $$v
                      },
                      expression: "contractNo"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.contractNo != null &&
          _vm.trackPhaseList != null &&
          _vm.trackPhaseList.length > 0
            ? _c("div", { staticClass: "form-single mt20 mb20" }, [
                _c("div", { staticClass: "title required" }, [
                  _vm._v("选择合同阶段")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "fl",
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.trackPhaseId,
                            callback: function($$v) {
                              _vm.trackPhaseId = $$v
                            },
                            expression: "trackPhaseId"
                          }
                        },
                        _vm._l(_vm.trackPhaseList, function(trackPhase) {
                          return _c("el-option", {
                            key: trackPhase.id,
                            attrs: {
                              label: trackPhase.name,
                              value: trackPhase.id
                            }
                          })
                        })
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title required" }, [_vm._v("配货方式")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.goodsOrder.manualAllocFlag,
                        callback: function($$v) {
                          _vm.$set(_vm.goodsOrder, "manualAllocFlag", $$v)
                        },
                        expression: "goodsOrder.manualAllocFlag"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("手工配货")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("自动配货")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("税率(%)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                [_c("span", [_vm._v(_vm._s(_vm.goodsOrder.taxRate))])]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("选择零售商")])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("选择零售商")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.contractBizRel.fstPartyName,
                        callback: function($$v) {
                          _vm.$set(_vm.contractBizRel, "fstPartyName", $$v)
                        },
                        expression: "contractBizRel.fstPartyName"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("业务开始日期")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.contractBizRel.dateStart,
                        callback: function($$v) {
                          _vm.$set(_vm.contractBizRel, "dateStart", $$v)
                        },
                        expression: "contractBizRel.dateStart"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("业务截止日期")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.contractBizRel.dateEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.contractBizRel, "dateEnd", $$v)
                        },
                        expression: "contractBizRel.dateEnd"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("配货机构信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-row" }, [
            _c("div", { staticClass: "left" }, [
              _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.showShopDlg()
                    }
                  }
                },
                [_vm._v("选择机构")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "custom-tbl" }, [
            _c("thead", { staticClass: "head" }, [
              _c("tr", { staticClass: "row" }, [
                _c("th", { staticClass: "align-left" }, [_vm._v("机构名称")]),
                _vm._v(" "),
                _c("th", { staticClass: "align-left" }, [_vm._v("地址")]),
                _vm._v(" "),
                _c("th", [_vm._v("邮箱")]),
                _vm._v(" "),
                _c("th", [_vm._v("操作")])
              ])
            ]),
            _vm._v(" "),
            _c("tbody", { staticClass: "body" }, [
              _vm.retailerCom != null
                ? _c("tr", { staticClass: "row" }, [
                    _c("td", { staticClass: "align-left" }, [
                      _vm._v(_vm._s(_vm.retailerCom.name))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "align-left" }, [
                      _vm._v(
                        _vm._s(
                          _vm.retailerCom.regionName + _vm.retailerCom.street
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.retailerCom.contactEmail))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "span",
                        {
                          staticClass: "swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.removeRetailerCom()
                            }
                          }
                        },
                        [_vm._v("移除")]
                      )
                    ])
                  ])
                : _c("tr", { staticClass: "row" }, [
                    _c("td", { attrs: { colspan: "4" } }, [
                      _vm._v("暂无机构信息")
                    ])
                  ])
            ])
          ]),
          _vm._v(" "),
          _vm.retailerCom != null
            ? _c("div", { staticClass: "btn-row bg-white" }, [
                _c("div", { staticClass: "left-btn fl" }, [
                  _c(
                    "a",
                    {
                      staticClass: "swb-btn swb-btn-small mr10",
                      on: {
                        click: function($event) {
                          _vm.showShopAddrDlg()
                        }
                      }
                    },
                    [_vm._v("选择地址")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.retailerCom != null
            ? _c("table", { staticClass: "custom-tbl" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c("th", [_vm._v("省市县")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("详细地址")])
                  ])
                ]),
                _vm._v(" "),
                _c("tbody", { staticClass: "body" }, [
                  _vm.retailerCom != null
                    ? _c("tr", { staticClass: "row" }, [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "inline-block mr10",
                              staticStyle: { width: "500px" }
                            },
                            [_vm._v(_vm._s(_vm.retailerCom.shopAddrRegionName))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "inline-block",
                              staticStyle: { width: "500px" },
                              attrs: { placeholder: "详细地址" },
                              model: {
                                value: _vm.retailerCom.shopAddrStreet,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.retailerCom,
                                    "shopAddrStreet",
                                    $$v
                                  )
                                },
                                expression: "retailerCom.shopAddrStreet"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _c("tr", { staticClass: "row" }, [
                        _c("td", { attrs: { colspan: "1" } }, [
                          _vm._v("暂无地址信息")
                        ])
                      ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("联系人信息")])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [_vm._v("联系人")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      attrs: { type: "input" },
                      model: {
                        value: _vm.contactName,
                        callback: function($$v) {
                          _vm.contactName = $$v
                        },
                        expression: "contactName"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("联系电话")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("el-input", {
                      attrs: { type: "input" },
                      model: {
                        value: _vm.contactTel,
                        callback: function($$v) {
                          _vm.contactTel = $$v
                        },
                        expression: "contactTel"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("商品信息")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.contractGoodsList,
                    border: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "title", label: "名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "catName", label: "分类" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "brandName", label: "品牌" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "model", label: "型号" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "fixedSpec", label: "规格" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "asmblAccFlag",
                      label: "组装件"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.asmblAccFlag ? "是" : "否")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "right", label: "含税价(元)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.checkActionPerm("view_item_price")
                              ? _c("div", [
                                  scope.row.price != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.price))
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ])
                              : _c("div", [_c("span", [_vm._v("没有权限")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "right", label: "税率(%)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.checkActionPerm("view_item_price")
                              ? _c("span", [_vm._v(_vm._s(scope.row.taxRate))])
                              : _c("span", [_vm._v("没有权限")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "ntxPrice",
                      label: "未税价(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.checkActionPerm("view_item_price")
                              ? _c("div", [
                                  scope.row.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.ntxPrice))
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ])
                              : _c("div", [_c("span", [_vm._v("没有权限")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "wrntPeriod",
                      label: "质保期(月)"
                    }
                  }),
                  _vm._v(" "),
                  _vm.contractNo != null &&
                  _vm.contractBizRel != null &&
                  _vm.contractBizRel.kindId != null &&
                  _vm.contractBizRel.kindId == 0
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          prop: "quantity",
                          label: "合同总数量"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractNo != null &&
                  _vm.contractBizRel != null &&
                  _vm.contractBizRel.kindId != null &&
                  _vm.contractBizRel.kindId == 0
                    ? _c("el-table-column", {
                        attrs: { align: "right", label: "剩余数量" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.quantity -
                                        scope.row.surplusQuantity
                                    ) + _vm._s(scope.row.unit)
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "unit",
                      label: "单位",
                      width: "80px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "right", label: "下单数量" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                disabled:
                                  scope.row.quantity -
                                    scope.row.surplusQuantity <=
                                    0 &&
                                  _vm.contractNo != null &&
                                  _vm.contractBizRel != null &&
                                  _vm.contractBizRel.kindId != null &&
                                  _vm.contractBizRel.kindId == 0,
                                type: "text"
                              },
                              on: {
                                change: function($event) {
                                  _vm.quantityChanges(scope)
                                }
                              },
                              model: {
                                value: scope.row.goodsQuantity,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goodsQuantity", $$v)
                                },
                                expression: "scope.row.goodsQuantity"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", label: "说明" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { type: "text" },
                              model: {
                                value: scope.row.desc,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "desc", $$v)
                                },
                                expression: "scope.row.desc"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeContractGoods(scope.row.skuId)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("到货日期")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title required" }, [
              _vm._v("要求到货日期")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "picker-options": _vm.pickerOptions0
                    },
                    model: {
                      value: _vm.goodsOrder.desireArriveDate,
                      callback: function($$v) {
                        _vm.$set(_vm.goodsOrder, "desireArriveDate", $$v)
                      },
                      expression: "goodsOrder.desireArriveDate"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.contractNo != null && _vm.goodsOrder.desireArriveDays != null
            ? _c("div", { staticClass: "form-single mt20 mb20" }, [
                _c("div", { staticClass: "title" }, [_vm._v("要求到货天数")]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.goodsOrder.desireArriveDays) + "   天 "
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("要求")])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("交易总金额")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderAndTradeDto.totalAmount))
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("附言")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "600px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "附言最大长度120个字",
                        maxlength: 120,
                        minlength: 10
                      },
                      model: {
                        value: _vm.servcOrder.postscript,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "postscript", $$v)
                        },
                        expression: "servcOrder.postscript"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-toolbar" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.saveGoodsOrder()
                }
              }
            },
            [_vm._v("提交")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16e3d574", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e3d574","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/ProxyGoodsOrder.vue
// module id = 2058
// module chunks = 1